<template>
  <ButtonTemplateMicInput text-button="DM" :on-click="actions.toggleDm">
    <template #icon-handler>
      <IconApecKeyboard />
    </template>
  </ButtonTemplateMicInput>
</template>

<script setup lang="ts">
import { inject } from 'vue';

import ButtonTemplateMicInput from '@/components/domains/chat/common/ButtonTemplateMicInput.vue';
import IconApecKeyboard from '@/components/icons/IconApecKeyboard.vue';
import { DEFAULT_CHAT_UI_STATE } from '@/utils/constants/chat';
import { ij_chat_ui } from '@/utils/injectionKeys';

const { actions } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE);
</script>
